import Tippy, { TippyProps } from "@tippy.js/react";
import React, { useState } from "react";
import styled from "styled-components";
import { style } from "./style";

type UsePopoverResult = {
  visible: boolean;
  togglePopover: () => void;
  onHide: () => void;
};

export const usePopover = (): UsePopoverResult => {
  const [isVisible, setIsVisible] = useState(false);
  const hidePopover = (): void => setIsVisible(false);
  const togglePopover = (): void => setIsVisible((prevState) => !prevState);
  return {
    visible: isVisible,
    onHide: hidePopover,
    togglePopover,
  };
};

const StyledTippy = styled(Tippy)`
  background: ${style.colors.white};
  border-radius: ${style.vars.borderRadius.base};
  border: ${style.vars.border.base};
  padding: ${style.vars.space["2"]};
  box-shadow: ${style.vars.boxShadow.top};

  &[x-placement^="top"] .tippy-arrow {
    border-top-color: ${style.colors.white};
  }
  &[x-placement^="left"] .tippy-arrow {
    border-left-color: ${style.colors.white};
  }
  &[x-placement^="right"] .tippy-arrow {
    border-right-color: ${style.colors.white};
  }
  &[x-placement^="bottom"] .tippy-arrow {
    border-bottom-color: ${style.colors.white};
  }
`;

export const Popover: React.FC<TippyProps> = ({ content, children, ...props }) => {
  return (
    <StyledTippy content={content} interactive={true} theme="light" placement="auto" arrow {...props}>
      {children}
    </StyledTippy>
  );
};
